export default __webpack_public_path__ + "static/media/category_b1.3c6f1426.svg";